import { geoPath, geoMercator } from "d3-geo"
import { deviation } from "d3-array"

function filterGeometry(geometry, filterByDeviation = false) {
  const target = Object.assign({}, geometry)
  if (target.geometry) {
    if (target.geometry.type === "MultiPolygon") {
      const { coordinates } = target.geometry
      const innerCoordinates = coordinates
        .map((c) => c[0])
        .sort((a, b) => b.length - a.length)
      const coordinateFilter =
        filterByDeviation && innerCoordinates.length > 1
          ? target.id === "036" // special case for Australia / Tasmania
            ? (c, i) => i < 2
            : (c) =>
                c.length >=
                Math.floor(deviation(innerCoordinates.map((c) => c.length)))
          : (c, i) => i < 1
      const filteredCoordinates = innerCoordinates.filter(coordinateFilter)
      target.geometry = {
        type: "Polygon",
        coordinates: filteredCoordinates,
      }
    }
  }
  return target
}

export function getCenter(path, geometry) {
  const target = filterGeometry(geometry)
  const [x, y] = path.centroid(target)
  return { x, y }
}

const maxGeometry = {
  type: "Feature",
  geometry: {
    type: "Polygon",
    coordinates: [
      [
        [-180, 72], // top left
        [180, 72], // top right
        [180, -58.49227331726442], // bottom right
        [-180, -58.49227331726442], // bottom left
      ],
    ],
  },
} // approx continent bounds excluding the artic

export function getBounds(path, geometry) {
  const maxBounds = path.bounds(maxGeometry)
  const bounds = path.bounds(geometry),
    dx = bounds[1][0] - bounds[0][0],
    y1 = Math.max(bounds[0][1], maxBounds[0][1]),
    dy = bounds[1][1] - y1,
    x = (bounds[0][0] + bounds[1][0]) / 2,
    y = (y1 + bounds[1][1]) / 2
  return { dx, dy, x, y }
}

export function scaleProjection(geometry, width, height) {
  const projection = geoMercator()
    .scale(1000)
    .rotate([-11, 0])
    .translate([width / 2, height / 2])
  const path = geoPath().projection(projection)
  if (!geometry) {
    return {
      projection,
      path,
      scale: 1,
      translate: [0, 0],
      x: 0,
      y: 0,
      dx: 100,
      dy: 100,
    }
  }
  const target =
    geometry.features.length > 1
      ? geometry
      : filterGeometry(geometry.features[0], true)
  let { dx, dy, x, y } = getBounds(path, target)
  let scale = 0.9 / Math.max(dx / width, dy / height) || 1
  const allHighRes =
    geometry.features.length === 1 &&
    geometry.features[0].properties.highResolution
  if (allHighRes) {
    dx *= 2
    dy *= 2
    scale *= 2
  }

  const translate = [width / 2 - scale * x, height / 2 - scale * y]
  return { projection, path, scale, translate, x, y, dx, dy }
}
